var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUploadNewMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.422 1.467h1.836V5.46h3.993v1.837h-3.993v3.992h-1.836V7.297h-3.993V5.46h3.993V1.467z",
    fill: "#54822B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32 2.314a.918.918 0 00-.919.918v19.166c0 .508.412.919.919.919h19.166c.507 0 .918-.41.918-.919V11.874h-1.837v9.615H3.238V4.15h8.814V2.314H2.32z",
    fill: "#54822B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.772 12.163l3.449 4.866 2.373-2.653 3.906 5.098h-15l5.272-7.31z",
    fill: "#54822B"
  })));
}

export default SvgIconUploadNewMedia;